export const washed = [
	{
		"id": 1,
		"jump": "washed1",
		"title": "Washed I",
		"pic": "../img/washed/washed-1.jpg",
		"alt": "Washed 1, Digital Art Series",
		"left": "image",
		"right": "reg"
	},
	{
		"id": 2,
		"jump": "washed2",
		"title": "Washed II",
		"pic": "../img/washed/washed-2.jpg",
		"alt": "Washed 2, Digital Art Series",
		"left": "imagewide",
		"right": "slim"
	},
]